<template>
	<div class="power-analy-page">
		<div class="station-list-column">
			<div class="station-list-card">
				<div class="station-list-title card-title">
					<div class="card-title-icon">
						<img src="../../../static/站点列表(1).png"/>
					</div>
					<div class="card-title-text">
						站点列表
					</div>
				</div>
				<div class="station-list-body">
					<div class="station-list-body-inner">
						<div class="station-list-content">
							<div class="station-search-row">
								<el-input
									placeholder="请输入站点名称"
									v-model="query.stationName"
									class="station-search-input"
									clearable
									@keyup.enter.native="refreshStationList"
								/>
								<el-button type="primary" icon="el-icon-search" class="search-btn" @click="refreshStationList()">搜索</el-button>
							</div>
							<div class="station-list-scroll" style="margin-top: 16px;overflow-y: auto;">
								<div v-if="stationList.length === 0" class="station-list-empty">暂无可用站点</div>
								<div class="station-list-item" style="border-radius: 8px;height: 50px;cursor: pointer;margin-top: 10px;"
								v-for="(item,index) in stationList" 
								:class="currentId == item.id ?'selectIt':'selectNo'" @click="loadData(item.id)" :key="item.id">
									<div class="station-list-row">
										<div class="station-list-item-icon">
											<img src="../../../static/25.png" style="width: 25px;height: 25px;"/>
										</div>
										<div class="station-list-name" :title="item.stationName">
											{{item.stationName}}
										</div>
										<div class="station-list-item-arrow">
											<img src="../../../static/26.png" style="width: 18px;height: 18px;"/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="power-analy-content">
			<div class="power-analy-content-inner">
				<div class="summary-section">
					<div class="summary-row">
						<!-- 站点信息卡片 -->
						<div class="station-info-card summary-card" style="background-color: var(--solar-surface, #002B4D);border: 1px solid var(--solar-border, #003567);border-radius: 12px;margin-top: 4px;">
							<div class="card-title">
								<div class="card-title-icon">
									<img src="../../../static/站点信息(1).png"/>
								</div>
								<div class="card-title-text">
									站点信息
								</div>
							</div>
							<div class="station-info-content">
								<div class="station-info-name">
									<div class="station-info-label">
										站点名称
									</div>
									<div class="station-info-value">{{stationInfo.stationName ? stationInfo.stationName : "暂无"}}</div>
								</div>
								<div class="station-info-row">
									<div class="station-info-item">
										<div class="station-info-label">
											电站类型
										</div>
										<div class="station-info-value" v-if="stationInfo.stationType == 1">基站叠光</div>
										<div class="station-info-value" v-else-if="stationInfo.stationType == 2">离网电站</div>
										<div class="station-info-value" v-else>暂无</div>
									</div>
									<div class="station-info-item">
										<div class="station-info-label">
											装机容量
										</div>
										<div class="station-info-value">{{stationInfo.installedCapacity ? stationInfo.installedCapacity : '0'}} KW</div>
									</div>
									<div class="station-info-item">
										<div class="station-info-label">
											电话
										</div>
										<div class="station-info-value">{{stationInfo.linkMobile ? stationInfo.linkMobile : "暂无"}}</div>
									</div>
								</div>
								<div class="station-info-address">
									<div class="station-info-label">
										站点位置
									</div>
									<div class="station-info-value">{{stationInfo.stationAddress ? stationInfo.stationAddress : "暂无"}}</div>
								</div>
							</div>
						</div>
						<!-- 经济收益卡片 -->
						<div class="summary-card income-summary-card" style="background-color: var(--solar-surface, #002B4D);border: 1px solid var(--solar-border, #003567);border-radius: 12px;margin-top: 4px;">
							<div class="card-title">
								<div class="card-title-icon">
									<img src="../../../static/经济效益(1).png"/>
								</div>
								<div class="card-title-text">
									经济收益
								</div>
							</div>
							<div class="income-card-list">
								<div class="income-card">
									<div style="color: var(--solar-text, #87CEFA);font-size: 15px;">
										日发电收益
									</div>
									<div class="income-card-icon">
										<img src="../../../static/今日收益.png" style="width: 36px;height: 40px;"/>
									</div>
									<div class="income-card-value">
										{{income.dayIncome ? income.dayIncome : 0}}
									</div>
									<div class="income-card-value">
										元
									</div>
								</div>
								<div class="income-card">
									<div style="color: var(--solar-text, #87CEFA);font-size: 15px;">
										月发电收益
									</div>
									<div class="income-card-icon">
										<img src="../../../static/本月收益.png" style="width: 36px;height: 40px;"/>
									</div>
									<div class="income-card-value">
										{{income.monthIncome ? income.monthIncome : 0}}
									</div>
									<div class="income-card-value">
										元
									</div>
								</div>
								<div class="income-card">
									<div style="color: var(--solar-text, #87CEFA);font-size: 15px;">
										总发电收益
									</div>
									<div class="income-card-icon">
										<img src="../../../static/本年收益 (1).png" style="width: 36px;height: 40px;"/>
									</div>
									<div class="income-card-value">
										{{income.totalIncome ? income.totalIncome : 0}}
									</div>
									<div class="income-card-value">
										元
									</div>
								</div>
							</div>
						</div>
						<!-- 天气预报卡片 -->
						<div class="summary-card weather-summary-card" style="background-color: var(--solar-surface, #002B4D);border: 1px solid var(--solar-border, #003567);border-radius: 12px;margin-top: 4px;">
							<div class="card-title">
								<div class="card-title-icon">
									<img src="../../../static/天气预报(1).png"/>
								</div>
								<div class="card-title-text" style="min-width: 60px;">
									天气预报
								</div>
								<div class="card-title-extra">
									数据更新时间：{{weather.reporttime ? weather.reporttime : "暂无"}}
								</div>
							</div>
							<div class="weather-card-list">
								<div class="weather-card"
								v-for="(item,index) in weather.casts" :key="index" :class="index == 0?'':'aaaaaa'">
									<div style="font-size: 16px;">
										{{item.date ? item.date.substring(5, 12) : "暂无"}}
									</div>
									<div style="font-size: 16px;">
										{{item.dayweather ? item.dayweather : "暂无"}}
									</div>
									<div style="font-size: 15px;">
										{{item.nighttemp_float ? item.nighttemp_float : "0"}}/{{item.daytemp_float ? item.daytemp_float : "0"}}°C
									</div>
									<div style="font-size: 16px;">
										{{item.daywind ? item.daywind : '暂无'}}风
									</div>
									<div style="font-size: 16px;">
										{{item.daypower ? item.daypower : '0'}}级
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- 能量流动图+发电量统计 -->
				<div class="charts-row">
					<!-- 能量流动图 -->
					<div class="chart-panel energy-flow-panel" style="background-color: var(--solar-surface, #002B4D);border: 1px solid var(--solar-border, #003567);border-radius: 12px">
						<div class="card-title">
							<div class="card-title-icon">
								<img src="../../../static/能量流动图(1).png"/>
							</div>
							<div class="card-title-text">
								能量流动图
							</div>
							<div class="mobile-swipe-hint">左右滑动查看</div>
						</div>
						<div class="energy-flow-body" style="background-color: var(--solar-page, #001A33);height: 358px;overflow: hidden;">
							<div class="energy-flow-canvas">
							<div class="bbbbb">
								<img src="../../../static/bbb4.gif" class="energy-flow-img" v-if="bcData.pvuNum == 4"/>
								<img src="../../../static/bbb3.gif" class="energy-flow-img" v-if="bcData.pvuNum == 3"/>
								<img src="../../../static/bbb2.gif" class="energy-flow-img" v-if="bcData.pvuNum == 2"/>
								<img src="../../../static/bbb1.gif" class="energy-flow-img" v-if="bcData.pvuNum == 1"/>
								<img src="../../../static/bbb0.gif" class="energy-flow-img" v-if="bcData.pvuNum == 0 || !bcData.pvuNum"/>
							</div>
							<div class="energy-flow-overlay">
								<div class="energy-flow-pv-list">
									<div class="energy-flow-pv-group energy-flow-pv-group-1">
										<div class="energy-flow-pv-row energy-flow-pv-row-1-u">
											<div class="energy-flow-pv-name">{{bcData.bcDataPvDTOs[0].name}}</div>
											<div class="energy-flow-value">{{bcData.bcDataPvDTOs[0].value}}</div>
										</div>
										<div class="energy-flow-pv-row energy-flow-pv-row-1-i">
											<div class="energy-flow-pv-name">{{bcData.bcDataPvDTOs[1].name}}</div>
											<div class="energy-flow-value">{{bcData.bcDataPvDTOs[1].value}}</div>
										</div>
									</div>
									<div class="energy-flow-pv-group energy-flow-pv-group-2">
										<div class="energy-flow-pv-row energy-flow-pv-row-2-u">
											<div class="energy-flow-pv-name">{{bcData.bcDataPvDTOs[2].name}}</div>
											<div class="energy-flow-value">{{bcData.bcDataPvDTOs[2].value}}</div>
										</div>
										<div class="energy-flow-pv-row energy-flow-pv-row-2-i">
											<div class="energy-flow-pv-name">{{bcData.bcDataPvDTOs[3].name}}</div>
											<div class="energy-flow-value">{{bcData.bcDataPvDTOs[3].value}}</div>
										</div>
									</div>
									<div class="energy-flow-pv-group energy-flow-pv-group-3">
										<div class="energy-flow-pv-row energy-flow-pv-row-3-u">
											<div class="energy-flow-pv-name">{{bcData.bcDataPvDTOs[4].name}}</div>
											<div class="energy-flow-value">{{bcData.bcDataPvDTOs[4].value}}</div>
										</div>
										<div class="energy-flow-pv-row energy-flow-pv-row-3-i">
											<div class="energy-flow-pv-name">{{bcData.bcDataPvDTOs[5].name}}</div>
											<div class="energy-flow-value">{{bcData.bcDataPvDTOs[5].value}}</div>
										</div>
									</div>
									<div class="energy-flow-pv-group energy-flow-pv-group-4">
										<div class="energy-flow-pv-row energy-flow-pv-row-4-u">
											<div class="energy-flow-pv-name">{{bcData.bcDataPvDTOs[6].name}}</div>
											<div class="energy-flow-value">{{bcData.bcDataPvDTOs[6].value}}</div>
										</div>
										<div class="energy-flow-pv-row energy-flow-pv-row-4-i">
											<div class="energy-flow-pv-name">{{bcData.bcDataPvDTOs[7].name}}</div>
											<div class="energy-flow-value">{{bcData.bcDataPvDTOs[7].value}}</div>
										</div>
									</div>
								</div>
								<div class="energy-flow-value energy-flow-gfgl">{{bcData.gfgl}}</div>
								<div class="energy-flow-value energy-flow-battery-dy">{{bcData.dy}}</div>
								<div class="energy-flow-value energy-flow-battery-dl">{{bcData.dl}}</div>
								<div class="energy-flow-value energy-flow-battery-gl">{{bcData.gl}}</div>
								<div class="energy-flow-value energy-flow-load-dy1">{{bcData.dy1}}</div>
								<div class="energy-flow-value energy-flow-load-dy2">{{bcData.dy2}}</div>
								<div class="energy-flow-value energy-flow-load-dl1">{{bcData.dl1}}</div>
								<div class="energy-flow-value energy-flow-load-dianl">{{bcData.dianl}}</div>
							</div>
							</div>
						</div>
					</div>
					<!-- 发电量统计 -->
					<div class="chart-panel generation-panel" style="background-color: var(--solar-surface, #002B4D);border: 1px solid var(--solar-border, #003567);border-radius: 12px">
						<div class="card-title">
							<div class="card-title-icon">
								<img src="../../../static/发电量统计(1).png"/>
							</div>
							<div class="card-title-text" style="min-width: 70px;">
								发电量统计
							</div>
							<div class="chart-title-tools">
								<div v-for="(item,index) in optTypeList" :key="index" :class="optTypeIndex==index?'aaaa1':'aaaa2'"
								:style="{marginLeft:index>0?'8px':'0px'}" @click="loadDataChart(index);">
									{{item}}
								</div>
								<div class="chart-date-picker">
									 <el-date-picker
									  v-model="value"
									  @change="wsss"
									  size="small"
									  type="monthrange"
									  range-separator="至"
									  class="chart-month-range"
									  popper-class="power-analy-date-popper"
									  />
								</div>
							</div>
						</div>
						<div>
							<div id="allCharts1111" class="chartsBox generation-chart"/>
						</div>
					</div>
				</div>
				<!-- 站点设备 -->
				<div class="station-device-panel">
					<div class="card-title">
						<div class="card-title-icon">
							<img src="../../../static/站点设备(1).png"/>
						</div>
						<div class="card-title-text">
							站点设备
						</div>
					</div>
					<div class="station-device-scroll">
						<!-- 无设备提示 -->
						<div v-if="deviceList.length === 0" style="width: 100%;text-align: center;color: var(--solar-text, #87CEFA);font-size: 16px;">
							该站点暂无设备数据
						</div>
						<!-- 有设备时渲染 -->
						<div class="device-pair" v-else v-for="(item,index) in deviceList" :key="item.id" :class="index>0?'hhhh':''">
							<div class="device-card"
							@click="showDbForm = true;optId = item.id">
								<div class="device-card-heading">
									<div>
										<img src="../../../static/电表.png" class="device-type-icon"/>
									</div>
									<div style="margin-left: 8px;font-size: 14px;color: var(--solar-text, #87CEFA);">电表</div>
								</div>
								<div class="device-card-body">
									<div>
										<img src="../../../static/DIANBIAO.jpg" style="width: 100px;height: 80px;"/>
									</div>
									<div style="margin-left: 12px;" :title="item.stationName ? item.stationName : (item.deviceName ? item.deviceName : '未命名')">
										<div style="display: flex;line-height: 24px;">
											<div style="color: var(--solar-muted, #6699CC);width: 40px;">设备名</div>
											<div style="color: var(--solar-text, #87CEFA);">
												{{item.stationName ? item.stationName.substring(0,6) : (item.deviceName ? item.deviceName.substring(0,6) : '未命名')}}
											</div>
										</div>
										<div style="display: flex;line-height: 24px;">
											<div style="color: var(--solar-muted, #6699CC);width: 40px;">数量</div>
											<div style="color: var(--solar-text, #87CEFA);">1</div>
										</div>
										<div style="display: flex;line-height: 24px;">
											<div style="color: var(--solar-muted, #6699CC);width: 40px;">状态</div>
											<div v-if="item.deviceStatus == 1" style="color: var(--solar-muted, #6699CC);">离线</div>
											<div v-else-if="item.deviceStatus == 2" style="color: var(--solar-primary, #00CCFF);">在线</div>
											<div v-else-if="item.deviceStatus == 4" style="color: var(--solar-danger, #FF6B6B);">告警</div>
											<div v-else style="color: var(--solar-muted, #6699CC);">

											</div>
										</div>
									</div>
									<div style="width: 10px;"></div>
								</div>
							</div>
							<div class="device-card"
							@click="showKzqForm = true;optId = item.id">
								<div class="device-card-heading">
									<div>
										<img src="../../../static/控制器.png" class="device-type-icon"/>
									</div>
									<div style="margin-left: 8px;font-size: 14px;color: var(--solar-text, #87CEFA);">控制器</div>
								</div>
								<div class="device-card-body">
									<div>
										<img src="../../../static/KZQ.jpg" style="width: 100px;height: 80px;"/>
									</div>
									<div style="margin-left: 12px;" :title="item.stationName ? item.stationName : (item.deviceName ? item.deviceName : '未命名')">
										<div style="display: flex;line-height: 24px;">
											<div style="color: var(--solar-muted, #6699CC);width: 40px;">设备名</div>
											<div style="color: var(--solar-text, #87CEFA);">
												{{item.stationName ? item.stationName.substring(0,6) : (item.deviceName ? item.deviceName.substring(0,6) : '未命名')}}
											</div>
										</div>
										<div style="display: flex;line-height: 24px;">
											<div style="color: var(--solar-muted, #6699CC);width: 40px;">数量</div>
											<div style="color: var(--solar-text, #87CEFA);">1</div>
										</div>
										<div style="display: flex;line-height: 24px;">
											<div style="color: var(--solar-muted, #6699CC);width: 40px;">状态</div>
											<div v-if="item.deviceStatus == 1" style="color: var(--solar-muted, #6699CC);">离线</div>
											<div v-else-if="item.deviceStatus == 2" style="color: var(--solar-primary, #00CCFF);">在线</div>
											<div v-else-if="item.deviceStatus == 4" style="color: var(--solar-danger, #FF6B6B);">告警</div>
											<div v-else style="color: var(--solar-muted, #6699CC);"></div>
										</div>
									</div>
									<div style="width: 10px;"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div id = 'container'></div>
		</div>
		<el-dialog
		  title="控制器详情"
		  :visible.sync="showKzqForm"
		  @close="showKzqForm = false;"
		  top="2vh"
		  custom-class="left-aligned-dialog"
		  width="80vw"
		  style="background-color: var(--solar-page, #001A33);border: 1px solid var(--solar-border, #003567);">
		  <deviceKzqViewVue :id="optId" v-if="showKzqForm"/>
		</el-dialog>
		<el-dialog
		  title="电表详情"
		  :visible.sync="showDbForm"
		  @close="showDbForm = false;"
		  top="2vh"
		  custom-class="left-aligned-dialog"
		  width="80vw"
		  style="background-color: var(--solar-page, #001A33);border: 1px solid var(--solar-border, #003567);">
		  <deviceDbViewVue :id="optId" v-if="showDbForm"/>
		</el-dialog>
	</div>
</template>

<script>
	import deviceKzqViewVue from './deviceKzqView.vue';
	import deviceDbViewVue from './deviceDbView.vue';
	import axios from 'axios'
	import * as echarts from 'echarts';
	import chartTheme from '../../mixins/chartTheme';
	export default {
		mixins: [chartTheme],
		components: {
		  deviceKzqViewVue,
		  deviceDbViewVue
		},
	    data() {
		  return {
			  screenHeight: 0,
			  screenWidth: 0,
			  chartInstance: null,
			  bcData:{
				  bcDataPvDTOs:[
					  {name:'',value:''},
					  {name:'',value:''},
					  {name:'',value:''},
					  {name:'',value:''},
					  {name:'',value:''},
					  {name:'',value:''},
					  {name:'',value:''},
					  {name:'',value:''}
				  ],
				  pvu1:0.00,pvi1:0.00,pvu2:0.00,pvi2:0.00,
				  pvu3:0.00,pvi3:0.00,pvu4:0.00,pvi4:0.00,
				  gfgl:0.00,dy:0.00,dl:0.00,gl:0.00,
				  dy1:0.00,dy2:0.00,dl1:0.00,dianl:0.00,
				  pvuNum:0
			  },
			  bcIndex:4,
			  optId:0,
			  showDbForm:false,
			  showKzqForm:false,
			  city:'',
			  weekDay:1,
			  weatherRetryTimer:null,
			  weather:{casts:[],reporttime:''},
			  deviceList:[],
			  queryChart:{},
			  value:'',
			  optTypeList:["月","年"],
			  optTypeIndex:0,
			  income:{dayIncome:0,monthIncome:0,totalIncome:0},
			  stationInfo:{},
			  query:{pageNum:1,pageSize:10000,stationName:""},
			  currentId:0,
			  stationList:[]
		  }
		},
		mounted() {
			// 初始化屏幕尺寸
			this.updateScreenWidth();
			// 加载站点列表
			this.loadStationList().then(() => this.initSelectedStation());
			// 监听窗口大小变化
			window.addEventListener('resize', this.updateScreenWidth);
		},
		beforeDestroy() {
			// 移除窗口监听并释放图表实例
			window.removeEventListener('resize', this.updateScreenWidth);
			if (this.chartInstance) {
				this.chartInstance.dispose();
				this.chartInstance = null;
			}
			if (this.weatherRetryTimer) {
				clearTimeout(this.weatherRetryTimer);
				this.weatherRetryTimer = null;
			}
		},
		methods:{
			updateScreenWidth() {
			  this.screenWidth = window.innerWidth;
			  this.screenHeight = window.innerHeight;
			  this.$nextTick(() => {
				  if (this.chartInstance) this.chartInstance.resize();
			  });
			},
			initSelectedStation() {
				if (!this.stationList.length) {
					this.currentId = 0;
					this.stationInfo = {};
					this.weather = {casts:[],reporttime:''};
					return;
				}
				const routeStationId = this.$route.query.stationId;
				const targetStation = routeStationId
					? this.stationList.find(item => item.id == routeStationId)
					: this.stationList[0];
				const selectedStation = targetStation || this.stationList[0];
				if (routeStationId && !targetStation) {
					this.$Message.warning("Station not found, loading the first station.");
				}
				this.loadData(selectedStation.id);
			},
			refreshStationList() {
				this.loadStationList().then(() => this.initSelectedStation());
			},
			getCityCode(retryCount = 0) {
				if (!this.stationInfo.longitude || !this.stationInfo.latitude) return;
				if (!window.AMap || !window.AMap.Geocoder) {
					if (retryCount < 10) {
						if (this.weatherRetryTimer) clearTimeout(this.weatherRetryTimer);
						this.weatherRetryTimer = setTimeout(() => {
							this.getCityCode(retryCount + 1);
						}, 300);
					}
					return;
				}
				try {
				    const geocoder = new window.AMap.Geocoder({
				        radius: 1000,
				        extensions: 'base'
				    });
					const that = this;
				    geocoder.getAddress([that.stationInfo.longitude, that.stationInfo.latitude], (status, result) => {
				        if (status === 'complete' && result.regeocode) {
				            const addressComponent = result.regeocode.addressComponent;
							fetch(`https://restapi.amap.com/v3/weather/weatherInfo?city=${addressComponent.adcode}&key=${process.env.VUE_APP_AMAP_WEATHER_KEY}&extensions=all`)
							    .then((response) => response.json())
							    .then((data) => {
									if (data.status === '1' && data.forecasts && data.forecasts.length){
									  that.weather.reporttime = data.forecasts[0].reporttime;
									  that.weather.casts = data.forecasts[0].casts || [];
									}
							    })
							    .catch(err => {
							      console.log('天气信息获取失败', err);
							    });
				        }
				    });
				} catch (err) {
					console.log('天气地理编码初始化失败', err);
				}
			},
			wsss(e){
				this.value = e;
				this.loadDataChart(this.optTypeIndex);
			},
			// 获取指定日期
			getWeekDayOf(i) {
			  const today = new Date();
			  const newDate = new Date(today);
			  newDate.setDate(newDate.getDate() + i);
			  return newDate.toLocaleDateString();
			},
			// 获取当前日期
			getWeekDay() {
			  const now = new Date();
			  this.weekDay = now.toLocaleDateString();
			},
			// 加载站点设备列表
			loadPage(){
				let query = {pageNum:1,pageSize:10000,stationId:this.currentId};
				this.$request.post("/api/device/page",query).then(response =>{
					if(response.data.result){
						this.deviceList = response.data.data.list ? response.data.data.list : [];
					}else{
						this.deviceList = [];
						this.$Message.error("获取设备数据失败,请联系管理员!");
					}
				}).catch(() => {
					this.deviceList = [];
					this.$Message.error("获取设备数据失败,请联系管理员!");
				})
			},
			// 加载发电量图表
			loadDataChart(i){
				if (!this.currentId) return;
				this.queryChart.powerStationId = this.currentId;
				this.optTypeIndex = i;
				this.queryChart.optType = (i+1);
				if(this.value != ''){
					this.queryChart.startTime = this.value[0];
					this.queryChart.endTime = this.value[1];
				}
				this.$request.post('/api/index/power/chart/data',this.queryChart).then(response => {
					if(response.data.result){
						this.initCharts(response.data.data);
					}
				}).catch(err => {
					console.log('图表数据加载失败', err);
				})
			},
			// 发电量图表配置
			initCharts(o) {
				if (!o || !o.times || !o.values) return;
				var chartDom = document.getElementById('allCharts1111');
				if (!chartDom) return;
				this.chartInstance = echarts.getInstanceByDom(chartDom) || echarts.init(chartDom);
				const isMobile = this.screenWidth <= 760;
				this.chartInstance.setOption({
					// 图表背景设为主题蓝
					backgroundColor: '#001A33',
					grid: {
						left: isMobile ? 10 : 24,
						right: isMobile ? 12 : 24,
						top: 48,
						bottom: isMobile ? 18 : 28,
						containLabel: true
					},
					// 全局文字色设为浅蓝
					textStyle: {color: '#87CEFA'},
					title: {
						text: '           kwh',
						textStyle: {color: '#87CEFA'}
					},
					xAxis: {
						data: o.times,
						axisLabel: {
							inside: false,
							color: '#87CEFA', // X轴文字浅蓝
							show: true,
							rotate: isMobile ? 35 : 0,
							fontSize: isMobile ? 10 : 12
						},
						axisTick: {
							show: true,
							lineStyle: {color: '#003567'} // 刻度线深蓝
						},
						axisLine: {
							show: true,
							lineStyle: {color: '#003567'} // 轴线深蓝
						},
						z: 10
					},
					yAxis: {
						axisLine: {show: false},
						axisTick: {show: false},
						axisLabel: {color: '#87CEFA'} // Y轴文字浅蓝
					},
					dataZoom: [{type: 'inside'}],
					series: [{
						type: 'bar',
						barMaxWidth: '20',
						showBackground: false,
						itemStyle: {
							// 进度条用主题蓝渐变
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#0099FF' },
								{ offset: 0.5, color: '#0066CC' },
								{ offset: 1, color: '#004A99' }
							])
						},
						label: {
							normal: {
								show: !isMobile,
								position: 'top',
								color: '#FFFFFF' // 数值文字白色
							}
						},
						data: o.values
					}]
				}, true);
				this.applyChartTheme();
				this.$nextTick(() => this.chartInstance && this.chartInstance.resize());
			},
			// 加载站点收益
			loadIncome(){
				if (!this.currentId) return;
				this.$request.get("/api/power/station/income/"+this.currentId).then(response =>{
					if(response.data.result){
						this.income = response.data.data ? response.data.data : {dayIncome:0,monthIncome:0,totalIncome:0};
					}else{
						this.income = {dayIncome:0,monthIncome:0,totalIncome:0};
					}
				}).catch(() => {
					this.income = {dayIncome:0,monthIncome:0,totalIncome:0};
				})
			},
			// 加载站点所有核心数据
			loadData(id){
				if (!id) return;
				this.currentId = id;
				// 依次加载数据
				this.loadDataChart(0); // 发电量图表
				this.info(); // 站点基本信息
				this.loadIncome(); // 经济收益
				this.loadPage(); // 站点设备
			},
			// 加载站点基本信息
			info(){
				if (!this.currentId) return;
				this.$request.get("/api/power/station/info/"+this.currentId).then(response =>{
					if(response.data.result){
						this.stationInfo = response.data.data ? response.data.data : {};
						this.loadCbData(); // 加载能量流动数据
						this.getCityCode(); // 获取天气
					}else{
						this.stationInfo = {};
						this.weather = {casts:[],reporttime:''};
					}
				}).catch(() => {
					this.stationInfo = {};
					this.weather = {casts:[],reporttime:''};
				})
			},
			// 加载能量流动数据
			loadCbData(){
				if (!this.currentId) return;
				this.$request.get("/api/device/get/bc/data/"+this.currentId).then(response =>{
					if(response.data.result){
						this.bcData = response.data.data ? response.data.data : {pvuNum:0, bcDataPvDTOs:new Array(8).fill({name:'',value:''})};
					}else{
						this.bcData = {pvuNum:0, bcDataPvDTOs:new Array(8).fill({name:'',value:''})};
					}
				}).catch(() => {
					this.bcData = {pvuNum:0, bcDataPvDTOs:new Array(8).fill({name:'',value:''})};
				})
			},
			// 加载站点列表（返回 Promise 方便后续操作）
			loadStationList(){
				return new Promise((resolve) => {
					this.$request.post("/api/power/station/page",this.query).then(response =>{
						if(response.data.result){
							this.stationList = response.data.data.list ? response.data.data.list : [];
						}else{
							this.stationList = [];
							this.$Message.error("获取站点列表失败,请联系管理员!");
						}
						resolve();
					}).catch(() => {
						this.stationList = [];
						this.$Message.error("获取站点列表失败,请联系管理员!");
						resolve();
					})
				})
			}
		}
	}
</script>

<style>
	.power-analy-date-popper {
		background-color: var(--solar-surface, #002B4D) !important;
		border: 1px solid var(--solar-border-strong, #0099FF) !important;
		color: var(--solar-text, #87CEFA) !important;
	}

	.power-analy-date-popper .el-date-picker,
	.power-analy-date-popper .el-picker-panel,
	.power-analy-date-popper .el-date-range-picker {
		background-color: var(--solar-surface, #002B4D) !important;
		color: var(--solar-text, #87CEFA) !important;
	}

	.power-analy-date-popper .el-date-table th,
	.power-analy-date-popper .el-picker-panel__icon-btn,
	.power-analy-date-popper .el-date-range-picker__header,
	.power-analy-date-popper .el-date-range-picker__content .el-date-range-picker__header div {
		color: var(--solar-text-strong, #B0E2FF) !important;
	}

	.power-analy-date-popper .el-date-table td.available:hover,
	.power-analy-date-popper .el-month-table td .cell:hover,
	.power-analy-date-popper .el-month-table td.current:not(.disabled) .cell {
		color: var(--solar-primary, #00CCFF) !important;
	}

	@media (max-width: 760px) {
		.power-analy-date-popper.el-picker-panel {
			left: 8px !important;
			width: calc(100vw - 16px) !important;
		}
		.power-analy-date-popper .el-date-range-picker__content {
			box-sizing: border-box;
			width: 50%;
			padding: 8px !important;
		}
		.power-analy-date-popper .el-month-table td {
			padding: 7px 1px;
		}
		.power-analy-date-popper .el-month-table td .cell {
			width: auto;
			font-size: 12px;
		}
		.left-aligned-dialog.el-dialog {
			width: calc(100vw - 16px) !important;
			max-height: 96vh;
			margin: 2vh auto 0 !important;
		}
		.left-aligned-dialog .el-dialog__body {
			box-sizing: border-box;
			max-height: calc(96vh - 55px);
			padding: 8px !important;
			overflow: auto;
		}
	}
</style>

<style scoped>
	.power-analy-page{
		display: flex;
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	.power-analy-content{
		flex: 1 1 auto;
		min-width: 0;
		margin-left: 4px;
		border-radius: 12px;
	}
	.power-analy-content-inner{
		box-sizing: border-box;
		width: calc(100% - 16px);
		margin-left: 8px;
	}
	.summary-row{
		display: flex;
		width: 100%;
	}
	.summary-section{
		height: 228px;
		border-radius: 12px;
	}
	.summary-card{
		flex: 1 1 0;
		min-width: 0;
	}
	.summary-card + .summary-card{
		margin-left: 12px;
	}
	.charts-row{
		display: flex;
		width: 100%;
		height: 408px;
		margin-top: 12px;
		border-radius: 12px;
	}
	.bbbbb2{
		width: 20%;
		color: var(--solar-success, #00FF0C);
	}
	.bbbbb1{
		width: 22%;
		overflow-y: auto;
	}
	.bbbbb{
		width: 100%;
		height: 358px;
		overflow: hidden;
	}
	.energy-flow-canvas{
		position: relative;
		width: 100%;
		height: 358px;
	}
	.energy-flow-img{
		display: block;
		width: 100%;
		height: 100%;
	}
	.energy-flow-overlay{
		position: absolute;
		inset: 0;
		color: var(--solar-text-strong, #FFFFFF);
		font-size: 12px;
		line-height: 16px;
		pointer-events: none;
	}
	.energy-flow-pv-list{
		position: absolute;
		left: 64px;
		width: 150px;
	}
	.energy-flow-pv-group{
		display: contents;
	}
	.energy-flow-pv-row{
		position: absolute;
		left: 0;
		display: flex;
		align-items: center;
		width: 100%;
		height: 16px;
		line-height: 16px;
		min-width: max-content;
		white-space: nowrap;
	}
	.energy-flow-pv-row-1-u{
		top: 19px;
	}
	.energy-flow-pv-row-1-i{
		top: 38px;
	}
	.energy-flow-pv-row-2-u{
		top: 81px;
	}
	.energy-flow-pv-row-2-i{
		top: 100px;
	}
	.energy-flow-pv-row-3-u{
		top: 145px;
	}
	.energy-flow-pv-row-3-i{
		top: 163px;
	}
	.energy-flow-pv-row-4-u{
		top: 207px;
	}
	.energy-flow-pv-row-4-i{
		top: 225px;
	}
	.energy-flow-pv-name{
		width: 42px;
		min-width: 42px;
		white-space: nowrap;
	}
	.energy-flow-value{
		color: var(--solar-success, #00FF0C);
		white-space: nowrap;
	}
	.energy-flow-pv-row .energy-flow-value{
		margin-left: 8px;
	}
	.energy-flow-gfgl{
		position: absolute;
		top: 73px;
		left: 257px;
		width: 38px;
		text-align: right;
	}
	.energy-flow-battery-dy,
	.energy-flow-battery-dl,
	.energy-flow-battery-gl,
	.energy-flow-load-dy1,
	.energy-flow-load-dy2,
	.energy-flow-load-dl1,
	.energy-flow-load-dianl{
		position: absolute;
		text-align: left;
	}
	.energy-flow-battery-dy,
	.energy-flow-battery-dl,
	.energy-flow-battery-gl{
		width: 42px;
		text-align: right;
	}
	.energy-flow-load-dy1,
	.energy-flow-load-dy2,
	.energy-flow-load-dl1,
	.energy-flow-load-dianl{
		width: 44px;
		text-align: right;
	}
	.energy-flow-battery-dy{
		top: 54px;
		left: 385px;
	}
	.energy-flow-battery-dl{
		top: 72px;
		left: 385px;
	}
	.energy-flow-battery-gl{
		top: 178px;
		left: 384px;
	}
	.energy-flow-load-dy1{
		top: 48px;
		left: 559px;
	}
	.energy-flow-load-dy2{
		top: 270px;
		left: 560px;
	}
	.energy-flow-load-dl1{
		top: 288px;
		left: 560px;
	}
	.energy-flow-load-dianl{
		top: 316px;
		left: 560px;
	}
	.card-title{
		display: flex;
		align-items: center;
		box-sizing: border-box;
		width: 100%;
		height: 48px;
		border-bottom: 2px solid var(--solar-border, #003567);
		overflow: hidden;
	}
	.card-title-icon{
		display: flex;
		align-items: center;
		justify-content: center;
		margin-left: 20px;
	}
	.card-title-icon img{
		display: block;
	}
	.card-title-text{
		margin-left: 10px;
		color: var(--solar-text, #87CEFA);
		font-size: 14px;
		line-height: 1;
	}
	.card-title-extra{
		margin-left: auto;
		margin-right: 10px;
		color: var(--solar-muted, #6699CC);
		font-size: 14px;
		line-height: 1;
	}
	.mobile-swipe-hint{
		display: none;
		margin-left: auto;
		margin-right: 14px;
		color: var(--solar-muted, #6699CC);
		font-size: 12px;
	}
	.station-info-card{
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		height: 220px;
		overflow: hidden;
	}
	.station-list-column{
		flex: 0 0 250px;
		width: 250px;
	}
	.station-list-card{
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		width: 242px;
		height: 844px;
		margin-top: 4px;
		margin-left: 4px;
		border: 1px solid var(--solar-border, #003567);
		border-radius: 12px;
		background-color: var(--solar-surface, #002B4D);
		overflow: hidden;
	}
	.station-list-title{
		flex-shrink: 0;
	}
	.station-list-body{
		flex: 1;
		min-height: 0;
		overflow: hidden;
	}
	.station-list-body-inner{
		height: 100%;
		min-height: 0;
	}
	.station-list-content{
		display: flex;
		flex-direction: column;
		box-sizing: border-box;
		width: 222px;
		height: 100%;
		margin-left: 10px;
		padding-top: 8px;
	}
	.station-search-row{
		display: flex;
		align-items: center;
		box-sizing: border-box;
		width: 100%;
		margin-top: 12px;
	}
	.station-search-input{
		flex: 1;
		min-width: 0;
		height: 36px;
		border: 1px solid var(--solar-border, #003567);
		border-radius: 4px;
		background-color: var(--solar-page, #001A33);
		box-shadow: none;
		box-sizing: border-box;
		overflow: hidden;
	}
	/deep/ .station-search-input .el-input,
	/deep/ .station-search-input .el-input__wrapper,
	/deep/ .station-search-input .el-input__wrapper:hover,
	/deep/ .station-search-input .el-input__wrapper.is-focus{
		border: 0 !important;
		background: transparent !important;
		box-shadow: none !important;
	}
	/deep/ .station-search-input .el-input__inner{
		box-sizing: border-box;
		height: 36px;
		line-height: 36px;
		padding: 0 12px;
		border: 0 !important;
		background: transparent !important;
		color: var(--solar-text, #87CEFA);
		box-shadow: none !important;
	}
	/deep/ .station-search-input .el-input__inner:hover,
	/deep/ .station-search-input .el-input__inner:focus{
		border: 0 !important;
		box-shadow: none !important;
	}
	/deep/ .station-search-input .el-input__inner::placeholder{
		color: rgba(var(--solar-text-rgb, 135, 206, 250), 0.62);
	}
	.search-btn{
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 88px;
		height: 36px;
		padding: 0;
		margin-left: 8px;
		border-radius: 4px;
		background-color: var(--solar-primary, #0099FF) !important;
		border-color: var(--solar-border-strong, #0099FF) !important;
		color: var(--solar-on-primary, #002B4D) !important;
		font-size: 14px;
		font-weight: 600;
		line-height: 1;
	}
	/deep/ .search-btn [class*="el-icon-"] + span{
		margin-left: 6px;
	}
	/deep/ .search-btn.el-button,
	/deep/ .search-btn.el-button span,
	/deep/ .search-btn.el-button i{
		color: var(--solar-on-primary, #002B4D) !important;
	}
	.station-info-content{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		flex: 1;
		box-sizing: border-box;
		width: calc(100% - 38px);
		height: auto;
		min-height: 0;
		margin: 10px 19px;
		padding: 12px 18px;
		border: 1px solid var(--solar-border, #003567);
		border-radius: 6px;
		background-color: var(--solar-page, #001A33);
		text-align: center;
		font-size: 14px;
	}
	.station-info-name,
	.station-info-address{
		width: 100%;
		min-width: 0;
	}
	.station-info-row{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		min-width: 0;
		margin: 12px 0;
	}
	.station-info-item{
		flex: 1;
		min-width: 0;
	}
	.station-info-label{
		color: var(--solar-muted, #6699CC);
		line-height: 20px;
	}
	.station-info-value{
		overflow: hidden;
		color: var(--solar-text, #87CEFA);
		line-height: 22px;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.income-card-list,
	.weather-card-list{
		display: flex;
		align-items: center;
		width: calc(100% - 42px);
		height: 170px;
		margin-left: 21px;
	}
	.income-card{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
		width: calc((100% - 20px)/3);
		height: 160px;
		border: 1px solid var(--solar-border, #003567);
		border-radius: 6px;
		background-color: var(--solar-page, #001A33);
		text-align: center;
	}
	.income-card + .income-card{
		margin-left: 10px;
	}
	.income-card-icon{
		margin-top: 8px;
	}
	.income-card-icon img{
		display: block;
	}
	.income-card-value{
		margin-top: 4px;
		color: var(--solar-text-strong, #FFFFFF);
		font-size: 14px;
		font-weight: bold;
		line-height: 1.2;
	}
	.weather-card{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 6px;
		box-sizing: border-box;
		width: calc((100% - 20px)/4);
		height: 160px;
		border: 1px solid var(--solar-border, #003567);
		border-radius: 6px;
		background-color: var(--solar-page, #001A33);
		color: var(--solar-text-strong, #FFFFFF);
		text-align: center;
	}
	.chart-panel{
		position: relative;
		box-sizing: border-box;
		height: 408px;
		overflow: hidden;
	}
	.energy-flow-panel{
		flex: 0 0 686px;
		width: 686px;
	}
	.generation-panel{
		flex: 1 1 0;
		min-width: 0;
		margin-left: 10px;
	}
	.generation-panel::after{
		content: "";
		position: absolute;
		inset: 0;
		z-index: 2;
		box-sizing: border-box;
		border: 1px solid var(--solar-border, #003567);
		border-radius: 12px;
		pointer-events: none;
	}
	.energy-flow-body,
	.generation-chart{
		box-sizing: border-box;
		display: block;
	}
	.energy-flow-body{
		position: relative;
		width: 100%;
	}
	.generation-chart{
		width: 100%;
		height: 358px;
	}
	.station-device-panel{
		box-sizing: border-box;
		height: 190px;
		margin-top: 10px;
		border: 1px solid var(--solar-border, #003567);
		border-radius: 12px;
		background-color: var(--solar-surface, #002B4D);
		overflow: hidden;
	}
	.station-device-scroll{
		display: flex;
		align-items: center;
		height: 138px;
		overflow-x: auto;
		overflow-y: hidden;
		overscroll-behavior-x: contain;
		scroll-snap-type: x proximity;
	}
	.device-pair{
		display: flex;
		margin-left: 12px;
	}
	.device-card{
		height: 130px;
		margin-top: 4px;
		margin-left: 8px;
		border: 1px solid var(--solar-border, #003567);
		border-radius: 12px;
		background-color: var(--solar-page, #001A33);
		cursor: pointer;
		scroll-snap-align: start;
	}
	.device-card-heading{
		display: flex;
		align-items: center;
		height: 22px;
		margin-top: 7px;
		margin-left: 12px;
	}
	.device-type-icon{
		display: block;
		width: 22px;
		height: 22px;
		object-fit: contain;
	}
	.device-card-body{
		display: flex;
		margin-top: 7px;
		margin-left: 12px;
		font-size: 12px;
	}
	.chart-title-tools{
		display: flex;
		align-items: center;
		margin-left: auto;
		margin-right: 12px;
	}
	.chart-date-picker{
		display: flex;
		align-items: center;
		margin-left: 12px;
	}
	/deep/ .chart-month-range.el-date-editor--monthrange{
		display: inline-flex !important;
		align-items: center !important;
		width: 240px !important;
		height: 32px !important;
		padding: 0 8px !important;
		border: 1px solid rgba(var(--solar-border-strong-rgb, 63, 184, 255), 0.5) !important;
		border-radius: 4px !important;
		background: rgba(var(--solar-page-rgb, 0, 26, 51), 0.92) !important;
		box-shadow: none !important;
		box-sizing: border-box;
		color: var(--solar-text, #87CEFA) !important;
	}
	/deep/ .chart-month-range.el-date-editor--monthrange:hover,
	/deep/ .chart-month-range.el-date-editor--monthrange.is-active{
		border-color: rgba(var(--solar-border-strong-rgb, 0, 204, 255), 0.85) !important;
	}
	/deep/ .chart-month-range.el-date-editor--monthrange .el-range__icon,
	/deep/ .chart-month-range.el-date-editor--monthrange .el-range-separator,
	/deep/ .chart-month-range.el-date-editor--monthrange .el-range__close-icon{
		display: inline-flex !important;
		align-items: center !important;
		justify-content: center !important;
		float: none !important;
		height: 30px !important;
		line-height: 30px !important;
		margin: 0 !important;
		padding: 0 !important;
		color: var(--solar-text, #87CEFA) !important;
	}
	/deep/ .chart-month-range.el-date-editor--monthrange .el-range__icon{
		flex: 0 0 20px;
	}
	/deep/ .chart-month-range.el-date-editor--monthrange .el-range-separator{
		flex: 0 0 28px;
		width: 28px !important;
		text-align: center;
	}
	/deep/ .chart-month-range.el-date-editor--monthrange .el-range-input{
		flex: 1 1 0;
		min-width: 0;
		height: 30px !important;
		line-height: 30px !important;
		padding: 0 !important;
		border: 0 !important;
		background: transparent !important;
		box-shadow: none !important;
		color: var(--solar-text, #87CEFA) !important;
		text-align: center;
	}
	/deep/ .chart-month-range.el-date-editor--monthrange .el-range-input::placeholder{
		color: rgba(var(--solar-text-rgb, 135, 206, 250), 0.62) !important;
	}
	.sssssssss4{
		background-image: url('../../../static/bbb4.gif');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
		color: var(--solar-text-strong, #FFFFFF);
		font-size: 14px;
	}
	.aaaaaa{
		margin-left: 10px;
	}
	.hhhh{
		margin-left: 0px !important;
	}
	/* 站点列表项样式 */
	.selectNo{
		border-radius: 10px;
		border: 1px solid var(--solar-border-strong, #0076B8);
		font-size: 16px;
		background-color: var(--solar-surface, #002B4D);
		color: var(--solar-text, #87CEFA);
		box-shadow: inset 0 0 0 1px rgba(var(--solar-primary-rgb, 0, 153, 255), 0.16);
	}
	.selectIt{
		background: var(--solar-primary, #0099FF);
		border-radius: 10px;
		font-size: 16px;
		color: var(--solar-on-primary, #002B4D);
	}
	/* 年月切换按钮 */
	.aaaa2{
		width: 2.5vw;
		height: 32px;
		background: var(--solar-surface, #002B4D);
		border-radius: 4px;
		border: 1px solid var(--solar-border, #003567);
		cursor: pointer;
		line-height: 1;
		text-align: center;
		font-size: 0.9vw;
		color: var(--solar-text, #87CEFA);
	}
	.aaaa1{
		width: 2.5vw;
		height: 32px;
		background: var(--solar-primary, #0099FF);
		border-radius: 4px;
		cursor: pointer;
		line-height: 1;
		text-align: center;
		color: var(--solar-on-primary, #002B4D);
		font-size: 0.9vw;
	}
	.aaaa1,
	.aaaa2{
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
	}
	/* 滚动条样式 */
	::-webkit-scrollbar {
		width: 6px;
		height: 6px;
		background-color: var(--solar-page, #001A33);
	}
	::-webkit-scrollbar-thumb {
		background-color: var(--solar-primary, #0099FF);
		border-radius: 3px;
	}
	::-webkit-scrollbar-track {
		background-color: var(--solar-surface, #002B4D);
		border-radius: 3px;
	}
	.station-list-row{
		display: flex;
		align-items: center;
		height: 100%;
		width: 100%;
	}
	.station-list-item-icon,
	.station-list-item-arrow{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.station-list-item-icon{
		margin-left: 10px;
	}
	.station-list-item-arrow{
		margin-right: 10px;
		margin-left: auto;
	}
	.station-list-item-icon img,
	.station-list-item-arrow img{
		display: block;
	}
	.station-list-scroll{
		flex: 1;
		min-height: 0;
		box-sizing: border-box;
		padding-right: 10px;
		overscroll-behavior: contain;
	}
	.station-list-empty{
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 80px;
		color: var(--solar-muted, #6699CC);
		font-size: 13px;
	}
	.station-list-item{
		width: 100%;
		box-sizing: border-box;
	}
	.station-list-name{
		flex: 1;
		min-width: 0;
		margin-left: 8px;
		font-size: 0.75vw;
		line-height: 1.2;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	@media (max-width: 760px) {
		.power-analy-page{
			display: block;
			height: 100%;
			padding: 10px 10px 24px;
			background: var(--solar-page, #001A33);
			overflow-x: hidden;
			overflow-y: auto;
			overscroll-behavior-y: contain;
			-webkit-overflow-scrolling: touch;
		}
		.station-list-column{
			width: 100%;
		}
		.station-list-card{
			width: 100%;
			height: 172px;
			margin: 0;
			border-radius: 10px;
		}
		.station-list-content{
			width: 100%;
			margin: 0;
			padding: 0 10px 10px;
		}
		.station-search-row{
			margin-top: 8px;
		}
		.station-search-input,
		.search-btn{
			height: 40px;
		}
		/deep/ .station-search-input .el-input__inner{
			height: 40px;
			line-height: 40px;
		}
		.search-btn{
			width: 82px;
		}
		.station-list-scroll{
			display: flex;
			flex: 0 0 auto;
			gap: 8px;
			width: 100%;
			height: 60px;
			margin-top: 8px !important;
			padding: 0 0 8px;
			overflow-x: auto;
			overflow-y: hidden !important;
			scroll-snap-type: x proximity;
		}
		.station-list-empty{
			flex: 0 0 100%;
			height: 50px;
		}
		.station-list-item{
			flex: 0 0 178px;
			margin-top: 0 !important;
			scroll-snap-align: start;
		}
		.station-list-name{
			font-size: 14px;
		}
		.power-analy-content{
			width: 100%;
			margin: 10px 0 0;
		}
		.power-analy-content-inner{
			width: 100%;
			margin: 0;
		}
		.summary-section{
			height: auto;
		}
		.summary-row{
			flex-direction: column;
			gap: 10px;
		}
		.summary-card,
		.station-info-card{
			flex: 0 0 auto;
			width: 100%;
			height: auto;
			min-height: 0;
			margin-top: 0 !important;
			border-radius: 10px !important;
		}
		.summary-card + .summary-card{
			margin-left: 0;
		}
		.card-title{
			height: 44px;
		}
		.card-title-icon{
			margin-left: 14px;
		}
		.card-title-text{
			font-size: 14px;
		}
		.card-title-extra{
			max-width: 58%;
			font-size: 11px;
			line-height: 16px;
			text-align: right;
			white-space: normal;
		}
		.station-info-content{
			width: auto;
			margin: 10px;
			padding: 12px;
			font-size: 13px;
		}
		.station-info-row{
			display: grid;
			grid-template-columns: repeat(2, minmax(0, 1fr));
			gap: 10px;
			margin: 10px 0;
		}
		.station-info-item:nth-child(3){
			grid-column: 1 / -1;
		}
		.station-info-value{
			white-space: normal;
			word-break: break-word;
		}
		.income-card-list{
			display: grid;
			grid-template-columns: repeat(3, minmax(0, 1fr));
			gap: 6px;
			box-sizing: border-box;
			width: 100%;
			height: auto;
			margin: 0;
			padding: 10px;
		}
		.income-card{
			width: 100%;
			height: 132px;
			padding: 8px 4px;
		}
		.income-card + .income-card{
			margin-left: 0;
		}
		.income-card > div:first-child{
			font-size: 12px !important;
		}
		.income-card-icon{
			margin-top: 6px;
		}
		.income-card-icon img{
			width: 30px !important;
			height: 34px !important;
		}
		.income-card-value{
			max-width: 100%;
			font-size: 12px;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.weather-card-list{
			box-sizing: border-box;
			width: 100%;
			height: 170px;
			margin: 0;
			padding: 8px 10px 10px;
			overflow-x: auto;
			overflow-y: hidden;
			scroll-snap-type: x proximity;
		}
		.weather-card{
			flex: 0 0 128px;
			height: 148px;
			scroll-snap-align: start;
		}
		.weather-card > div{
			font-size: 13px !important;
		}
		.aaaaaa{
			margin-left: 8px;
		}
		.charts-row{
			flex-direction: column;
			gap: 10px;
			height: auto;
			margin-top: 10px;
		}
		.chart-panel{
			width: 100%;
			border-radius: 10px !important;
		}
		.energy-flow-panel{
			flex: 0 0 auto;
			height: 404px;
		}
		.mobile-swipe-hint{
			display: block;
		}
		.energy-flow-body{
			width: 100%;
			overflow-x: auto !important;
			overflow-y: hidden !important;
			overscroll-behavior-x: contain;
			-webkit-overflow-scrolling: touch;
		}
		.energy-flow-canvas{
			width: 686px;
			min-width: 686px;
		}
		.generation-panel{
			flex: 0 0 auto;
			height: 438px;
			margin-left: 0;
		}
		.generation-panel > .card-title{
			align-content: center;
			flex-wrap: wrap;
			height: 108px;
			padding: 8px 10px;
		}
		.generation-panel > .card-title .card-title-icon{
			margin-left: 4px;
		}
		.chart-title-tools{
			flex: 0 0 100%;
			width: 100%;
			margin: 8px 0 0;
		}
		.aaaa1,
		.aaaa2{
			flex: 0 0 48px;
			width: 48px;
			height: 40px;
			font-size: 14px;
		}
		.chart-date-picker{
			flex: 1;
			min-width: 0;
			margin-left: 8px;
		}
		/deep/ .chart-month-range.el-date-editor--monthrange{
			width: 100% !important;
			height: 40px !important;
		}
		.generation-chart{
			height: 328px;
		}
		.station-device-panel{
			height: 222px;
			margin-top: 10px;
			border-radius: 10px;
		}
		.station-device-scroll{
			height: 176px;
			padding: 0 10px 4px 2px;
		}
		.device-pair{
			margin-left: 0;
		}
		.device-card{
			flex: 0 0 264px;
			height: 154px;
			margin-left: 8px;
		}
		.device-card-heading{
			height: 28px;
			margin-top: 9px;
		}
		.device-card-body{
			margin-top: 9px;
		}
	}

	@media (max-width: 360px) {
		.power-analy-page{
			padding-right: 8px;
			padding-left: 8px;
		}
		.chart-title-tools{
			margin-top: 6px;
		}
		.aaaa1,
		.aaaa2{
			flex-basis: 42px;
			width: 42px;
		}
		/deep/ .chart-month-range.el-date-editor--monthrange{
			padding: 0 4px !important;
		}
		/deep/ .chart-month-range.el-date-editor--monthrange .el-range__icon{
			display: none !important;
		}
	}
</style>
